import { useNavigate } from "react-router-dom";

import {
  Breadcrumb,
  Button,
  MenuButton,
  Modal,
  ResponsivePrimaryNav,
} from "../../../components/ui";

const PrimaryNav = () => {
  const navigate = useNavigate();

  // prepare steps for breadcrumbs
  const steps = [{ label: "All Lists", onClick: () => navigate("/list") }];

  const breadcrumbProps = {
    currentStepIndex: steps?.length - 1,
    onChange: index => steps[index]?.onClick(),
    steps: steps?.map(item => item?.label),
  };

  const reportsMenuProps = {
    label: "Reports",
    options: [{ label: "Address Labels" }],
  };

  // const actionMenuProps = {
  //   label: "Actions",
  //   options: [{ label: "New List" }],
  // };

  return (
    <ResponsivePrimaryNav>
      <div>
        <Breadcrumb {...breadcrumbProps} />
      </div>
      <div className="flex items-center gap-2 sm:gap-4 lg:justify-end">
        <Modal>
          <Button label="Select List Search" action="black" />
        </Modal>
        <MenuButton {...reportsMenuProps} />
        {/* <MenuButton {...actionMenuProps} /> */}
      </div>
    </ResponsivePrimaryNav>
  );
};

export default PrimaryNav;
